import { useExplorer } from "@/context/ExplorerContext";
import { ImageSlot, hasImage } from "@/components/lurio/ImageSlot";
import { Eyebrow, Section } from "@/components/lurio/Primitives";
import { Reveal, Stamp } from "@/components/lurio/Motion";

export default function Quality() {
  const { t } = useExplorer();
  const q = t.quality;
  return (
    <Section id="qualite" bg="bg-cream-deep" className="grain">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="order-2 grid grid-cols-2 gap-4 lg:order-1 lg:col-span-7">
          <Reveal className="col-span-2 sm:col-span-1">
            <div className="rotate-[1deg] rounded-book bg-cream-card p-2 shadow-[0_18px_40px_-24px_rgba(30,42,56,0.45)]">
              <ImageSlot id="back_cover" rounded="rounded-[12px]" />
            </div>
          </Reveal>
          {(hasImage("macro_spiral") || hasImage("macro_sticker")) && (
            <div className="col-span-2 flex flex-col gap-4 sm:col-span-1">
              {hasImage("macro_spiral") && <Reveal delay={0.05}><ImageSlot id="macro_spiral" className="rotate-[-1deg]" /></Reveal>}
              {hasImage("macro_sticker") && <Reveal delay={0.1}><ImageSlot id="macro_sticker" className="rotate-[0.6deg]" /></Reveal>}
            </div>
          )}
          {hasImage("macro_paper") && (
            <Reveal delay={0.12} className="col-span-2 sm:col-span-1 sm:col-start-2 sm:-mt-10">
              <ImageSlot id="macro_paper" className="rotate-[-0.8deg]" />
            </Reveal>
          )}
        </div>
        <div className="order-1 lg:order-2 lg:col-span-5">
          <Reveal><Eyebrow className="mb-5">{q.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] text-ink sm:text-5xl">{q.title}</h2></Reveal>
          <Stamp delay={0.1} className="mt-8 inline-block">
            <div data-testid="moroccan-design-badge" className="sticker peel relative flex h-40 w-40 rotate-[4deg] flex-col items-center justify-center bg-blue p-4 text-center text-cream">
              <span className="absolute inset-2 rounded-full border border-dashed border-cream/50" aria-hidden />
              <span className="font-serif text-xl font-bold leading-tight">{q.stamp}</span>
              <span className="mt-1 text-[0.7rem] font-medium leading-snug text-cream/80">{q.stampSub}</span>
            </div>
          </Stamp>
          <Reveal delay={0.15} className="mt-10">
            <h3 className="font-serif text-2xl font-bold text-blue">{q.spiralTitle}</h3>
            <p className="mt-3 text-[1.05rem] leading-[1.85] text-ink-soft">{q.spiral}</p>
          </Reveal>
          <Reveal delay={0.2} className="mt-8">
            <dl className="divide-y divide-ink/10 border-y border-ink/10">
              {q.specs.map((s) => (
                <div key={s.k} className="flex justify-between gap-6 py-3 text-sm">
                  <dt className="font-bold text-ink-soft">{s.k}</dt>
                  <dd className="text-end font-semibold text-ink"><bdi>{s.v}</bdi></dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
